/**
 * ページ内スクロールのユーティリティ。
 *
 * ヘッダ include 側のレイアウト（ICE 管理 / リポジトリ外）が
 *
 *     body            { height: 100%; overflow: hidden }
 *     .global-content { overflow-y: auto }
 *
 * という構成になっており、**スクロールしているのは window ではなく
 * `.global-content`**（DOM: body > .root > .root-in > .global-container > .global-content）。
 *
 * そのため、window をスクロールさせる前提で書かれた以下はいずれも効かない。
 *
 *   - vue-router の scrollBehavior が返す { x: 0, y: 0 }（= window.scrollTo）
 *   - htdocs/js/detail.js の $('body,html').animate({ scrollTop: 0 })
 *   - <a href="#pagetop">（作品詳細にはアンカー先の要素自体が無い。
 *     スケジュールは body#pagetop があるが、body は .global-content の
 *     外側なのでやはりスクロールしない）
 *
 * レイアウトが元に戻った場合に備えて window へのフォールバックも持たせる。
 */

/** 実際にスクロールしている要素。旧レイアウトでは null（= window スクロール） */
export function scrollContainer () {
  return document.querySelector('.global-content')
}

/**
 * セレクタで指定した要素の位置へスクロールする（省略時はページ先頭）。
 *
 * セレクタを指定したのに該当要素が無い場合は**何もしない**。
 * スケジュールの SP 用日付タブが `:to="item + '#nav'"` を指しているが、
 * 肝心の `id="nav"` は現在コメントアウトされていて存在しないため、
 * ここで先頭へ飛ばすと従来と違う挙動になってしまう。
 */
export function scrollToElement (selector) {
  const container = scrollContainer()
  const target = selector ? document.querySelector(selector) : null

  if (selector && !target) return

  if (!container) {
    // window がスクロールコンテナの場合（旧レイアウト / index.html.dev）
    if (target) target.scrollIntoView()
    else window.scrollTo(0, 0)
    return
  }

  if (target) {
    container.scrollTop += target.getBoundingClientRect().top - container.getBoundingClientRect().top
  } else {
    container.scrollTop = 0
  }
}

/** ページ先頭へスクロールする */
export function scrollToTop () {
  scrollToElement(null)
}

/**
 * 「↑このページの先頭へ」リンクを有効にする。
 *
 * リンクが Vue の描画後に現れるページがあるため、document への委譲で受ける。
 *
 * ただし htdocs/js/detail.js（サーバ側 / ICE 管理。upload.sh の転送対象外なので
 * こちらからは直せない）が `.pagetop` に jQuery で click を bind しており、
 * その中で `return false` している＝ stopPropagation されるため、
 * バブリングでは document まで上がってこない。
 * **キャプチャフェーズで受けること。**（第3引数 true を外すと再発する）
 */
export function bindPageTopLinks () {
  document.addEventListener('click', (e) => {
    if (!closest(e.target, '.pagetop a, .goto-pagetop a')) return
    e.preventDefault()
    scrollToTop()
  }, true)
}

function closest (el, selector) {
  for (; el && el.nodeType === 1; el = el.parentElement) {
    if (el.matches && el.matches(selector)) return el
  }
  return null
}



// WEBPACK FOOTER //
// ./src/scroll.js